import React, { FC, PropsWithChildren } from "react";
import "./Button.scss";

export interface ButtonProps {
    readonly className?: string;
    readonly expand?: boolean;
    onClick(): void;
}

export const Button: FC<PropsWithChildren<ButtonProps>> = props => {
    const { className, expand, onClick } = props;
    return (
        <button
            type="button"
            className={`xapp-search-btn ${expand ? "xapp-search-btn--expand" : ""} ${className || ""}`}
            onClick={onClick}
        >{props.children}</button>
    );
};